module.exports = "/img/_/_/_/assets/images/payment_item//diamonds150.png?9ee8cd696503b819cda0a3580f0e0843";